<rt-dialog-body [variant]="'white'" layout layout-justify-center>
  <div layout-vertical layout-align-items-center>
    <div class="img-wrap" layout-centered margin-tb-medium>
      <img [src]="imageSrc" alt="" />
    </div>
    <div layout-vertical layout-align-items-center>
      <rt-heading variant="heading large-xx dark">
        {{
          (isJobAlreadyCreated
            ? 'app.requisitions.approved_success_dialog.job_created_heading'
            : 'app.requisitions.approved_success_dialog.heading'
          ) | translate
        }}
      </rt-heading>
      <div
        [innerHTML]="
          (isJobAlreadyCreated
            ? 'app.requisitions.approved_success_dialog.job_created_description'
            : 'app.requisitions.approved_success_dialog.description'
          ) | translate: { requisitionName: requisitionName }
        "
        text-center
        margin-top-small-xx
      ></div>
    </div>
  </div>
</rt-dialog-body>
@if (canCreateJob) {
  <rt-dialog-footer layout-centered>
    <rt-button variant="outline" (click)="close()">
      @if (isJobAlreadyCreated) {
        <span>
          {{ 'app.requisitions.approved_success_dialog.thanks_label' | translate }}
        </span>
      }
      @if (!isJobAlreadyCreated) {
        <span>
          {{ 'app.requisitions.approved_success_dialog.create_job_later_label' | translate }}
        </span>
      }
    </rt-button>

    @if (isJobAlreadyCreated && hasAccessToJob) {
      <rt-button variant="primary" [routerLink]="['/offers', offerSlug, 'edit']">
        <span>
          {{ 'app.requisitions.approved_success_dialog.job_created_label' | translate }}
        </span>
      </rt-button>
    }
    @if (!isJobAlreadyCreated) {
      <rt-button variant="primary" (click)="createJob()">
        <span>
          {{ 'app.requisitions.approved_success_dialog.create_job_label' | translate }}
        </span>
      </rt-button>
    }
  </rt-dialog-footer>
}
@if (!canCreateJob) {
  <rt-dialog-footer layout-centered>
    <rt-button variant="outline" (click)="close()">
      @if (isJobAlreadyCreated) {
        <span>
          {{ 'app.requisitions.approved_success_dialog.thanks_label' | translate }}
        </span>
      }
      @if (!isJobAlreadyCreated) {
        <span>
          {{ 'app.requisitions.approved_success_dialog.got_it_label' | translate }}
        </span>
      }
    </rt-button>
  </rt-dialog-footer>
}
